import { useTheme } from "next-themes";
import { InfoIcon, Loader2Icon, OctagonXIcon, TriangleAlertIcon } from "lucide-react";
import { CheckCircle } from "@untitledui/icons";
import { Toaster as Sonner } from "sonner";

const Toaster = ({ ...props }: any) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as any}
      className="toaster group"
      style={
        {
          "--toast-icon-margin-start": "0px",
          "--toast-icon-margin-end": "0px",
          "--toast-padding-y": "12px",
        } as React.CSSProperties
      }
      icons={{
        success: <CheckCircle className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      toastOptions={{
        classNames: {
          // Important: sonner's own theme rule ([data-styled] — var(--normal-bg)) outranks a
          // plain class, which left every toast white instead of the design system's dark one.
          // !w-fit: as wide as its content (anchored right, so it grows leftward), up to the toaster's width.
          toast: "!bg-zinc-950 !text-white !border-zinc-950 !py-3 !w-fit",
          title: "text-white",
          description: "!text-zinc-300",
          icon: "text-muted-foreground",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
